<div class="header">
  <div class="header-cont tables">
    <h2>{{ 'admin_user.title' | translate }}</h2>
    <button mat-raised-button class="page-header-btns add-element" [routerLink]="['/lista-utenti/nuovo-utente']">
      <mat-icon>add_location</mat-icon>
    </button>
  </div>
</div>

<div class="single-section">
  <div class="section-cont tables">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'admin_user.search_label' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>

<div class="admin-table">
  <table mat-table [dataSource]="dataSource">

    <!-- User name Column -->
    <ng-container matColumnDef="user_name">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_user.columns.user' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.name}}
      </td>
    </ng-container>

    <!-- Area Column -->
    <ng-container matColumnDef="area">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_user.columns.area' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{
          row.auth_user !== 'superadmin' ?
            row.geopos[0].name[current_lang] :
            '-'
        }}
      </td>
    </ng-container>

    <!-- Authorization Column -->
    <ng-container matColumnDef="authorization">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_user.columns.auth' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.auth_user | translate}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [routerLink]="['/lista-utenti/'+row.id, row]">
    </tr>
  </table>

  <mat-paginator class="mat-paginator-sticky" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
